import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import HomeMain from '../HomeMain/index'
import Scrollbar from '../../components/scrollbar'
import AdminLogin from '../../admin/pages/AdminLogin'
import AdminDashboard from '../../admin/pages/AdminDashboard'
import AdminUsers from '../../admin/pages/AdminUsers'
import SiteSettings from '../../admin/pages/SiteSettings'
import AdminCouple from '../../admin/pages/AdminCouple'
import AdminStory from '../../admin/pages/AdminStory'
import AdminEvents from '../../admin/pages/AdminEvents'
import AdminGallery from '../../admin/pages/AdminGallery'
import AdminMessages from '../../admin/pages/AdminMessages'
import ProtectedRoute from '../../admin/components/ProtectedRoute'
import { SiteSettingsProvider } from '../../siteSettings'
import NotFoundPage from '../NotFoundPage'
import VisitTracker from '../../analytics/VisitTracker'

      

const AllRoute = () => { 

  return (
    <div className="App">
       <Router>
            <SiteSettingsProvider>
            <VisitTracker />
            <Switch>
              <Route exact path='/' component={HomeMain} />
              <Route exact path='/admin/login' component={AdminLogin} />
              <ProtectedRoute exact path='/admin/dashboard' component={AdminDashboard} />
              <ProtectedRoute path='/admin/users' component={AdminUsers} />
              <ProtectedRoute exact path='/admin/couple' component={AdminCouple} />
              <ProtectedRoute exact path='/admin/story' component={AdminStory} />
              <ProtectedRoute exact path='/admin/events' component={AdminEvents} />
              <ProtectedRoute exact path='/admin/gallery' component={AdminGallery} />
              <ProtectedRoute exact path='/admin/messages' component={AdminMessages} />
              <ProtectedRoute exact path='/admin/site-settings' component={SiteSettings} />
              <Route exact path='/not-found' component={NotFoundPage} />
              <Redirect to='/not-found' />
            </Switch>
            </SiteSettingsProvider>
            <Scrollbar />
          </Router>
      
    </div>
  );
}

export default AllRoute;
